(() => {
  const ROOT_SELECTOR = '[data-sc-uv-catalog]';
  const FAMILY_CONFIG = [
    { key: 'plana', label: 'UV cama plana' },
    { key: 'rollo', label: 'UV rollo a rollo' },
    { key: 'hibrida', label: 'UV híbrida y multitecnología' },
    { key: 'dtf', label: 'UV DTF y etiquetas cristal' },
    { key: 'cilindrica', label: 'UV cilíndrica' },
    { key: 'industrial', label: 'UV industrial' }
  ];

  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

  const initialize = (root) => {
    if (!root || root.dataset.scUvReady === 'true') return;
    const source = root.querySelector('[data-sc-gf-source]');
    const groupsHost = root.querySelector('[data-sc-gf-groups]');
    const search = root.querySelector('[data-sc-gf-search]');
    const clear = root.querySelector('[data-sc-gf-clear]');
    const count = root.querySelector('[data-sc-gf-result-count]');
    const label = root.querySelector('[data-sc-gf-result-label]');
    const empty = root.querySelector('[data-sc-gf-empty]');
    const filters = Array.from(root.querySelectorAll('[data-sc-gf-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-sc-gf-card]'));
    if (!source || !groupsHost || cards.length === 0) return;
    root.dataset.scUvReady = 'true';
    cards.forEach((card) => { card.dataset.searchNormalized = normalize(card.dataset.search); });

    const familyGroups = new Map();
    const controls = [];
    FAMILY_CONFIG.forEach((family) => {
      const familyCards = cards.filter((card) => card.dataset.family === family.key);
      if (familyCards.length === 0) return;
      const section = document.createElement('section');
      section.className = 'sc-gf__group';
      section.dataset.scGfGroup = family.key;
      section.innerHTML =
        '<div class="sc-gf__group-header"><div><h3 class="sc-gf__group-title">' + family.label +
        '</h3><span class="sc-gf__group-count" data-sc-gf-group-count></span></div>' +
        '<div class="sc-gf__controls" aria-label="Controles de ' + family.label + '">' +
        '<button class="sc-gf__arrow" type="button" data-sc-gf-prev aria-label="Mostrar máquinas anteriores">←</button>' +
        '<button class="sc-gf__arrow" type="button" data-sc-gf-next aria-label="Mostrar siguientes máquinas">→</button>' +
        '</div></div><div class="sc-gf__track" data-sc-gf-track role="region" aria-roledescription="carrusel" aria-label="' +
        family.label + '" tabindex="0"></div>';
      const track = section.querySelector('[data-sc-gf-track]');
      familyCards.forEach((card) => track.appendChild(card));
      groupsHost.appendChild(section);
      familyGroups.set(family.key, {
        section,
        track,
        count: section.querySelector('[data-sc-gf-group-count]'),
        prev: section.querySelector('[data-sc-gf-prev]'),
        next: section.querySelector('[data-sc-gf-next]')
      });
    });

    root.classList.add('is-enhanced');
    let activeFamily = 'all';
    let query = '';
    let searchFrame = 0;
    const visibleCards = (track) => Array.from(track.querySelectorAll('[data-sc-gf-card]')).filter((card) => !card.hidden);
    const maxScroll = (track) => Math.max(0, track.scrollWidth - track.clientWidth);
    const syncControls = (group) => {
      const maximum = maxScroll(group.track);
      const disabled = visibleCards(group.track).length <= 1 || maximum <= 2;
      group.prev.disabled = disabled || group.track.scrollLeft <= 2;
      group.next.disabled = disabled || group.track.scrollLeft >= maximum - 2;
      group.prev.setAttribute('aria-disabled', String(group.prev.disabled));
      group.next.setAttribute('aria-disabled', String(group.next.disabled));
    };
    const step = (track) => {
      const card = visibleCards(track)[0];
      if (!card) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const cardWidth = card.getBoundingClientRect().width + gap;
      return cardWidth * Math.max(1, Math.round((track.clientWidth + gap) / cardWidth));
    };

    familyGroups.forEach((group) => {
      let dragStartX = 0;
      let dragStartScroll = 0;
      let dragMoved = false;
      let activePointerId = null;

      const move = (direction) => group.track.scrollBy({
        left: direction * step(group.track),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      group.prev.addEventListener('click', () => move(-1));
      group.next.addEventListener('click', () => move(1));
      group.track.addEventListener('scroll', () => syncControls(group), { passive: true });
      group.track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });

      group.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        activePointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScroll = group.track.scrollLeft;
        dragMoved = false;
      });

      group.track.addEventListener('pointermove', (event) => {
        if (activePointerId !== event.pointerId) return;
        const distance = event.clientX - dragStartX;
        if (Math.abs(distance) > 4 && !dragMoved) {
          dragMoved = true;
          group.track.setPointerCapture(event.pointerId);
          group.track.classList.add('is-dragging');
        }
        if (!dragMoved) return;
        event.preventDefault();
        group.track.scrollLeft = dragStartScroll - distance;
      });

      const endDrag = (event) => {
        if (activePointerId !== event.pointerId) return;
        if (group.track.hasPointerCapture(event.pointerId)) {
          group.track.releasePointerCapture(event.pointerId);
        }
        activePointerId = null;
        group.track.classList.remove('is-dragging');
        syncControls(group);
        if (dragMoved) {
          window.setTimeout(() => {
            dragMoved = false;
          }, 0);
        }
      };

      group.track.addEventListener('pointerup', endDrag);
      group.track.addEventListener('pointercancel', endDrag);
      group.track.addEventListener('click', (event) => {
        if (!dragMoved) return;
        event.preventDefault();
        event.stopPropagation();
        dragMoved = false;
      }, true);

      controls.push(group);
    });

    const apply = () => {
      let total = 0;
      familyGroups.forEach((group, familyKey) => {
        const allowed = activeFamily === 'all' || activeFamily === familyKey;
        let familyTotal = 0;
        Array.from(group.track.querySelectorAll('[data-sc-gf-card]')).forEach((card) => {
          const visible = allowed && (!query || card.dataset.searchNormalized.includes(query));
          card.hidden = !visible;
          if (visible) { familyTotal += 1; total += 1; }
        });
        group.section.hidden = familyTotal === 0;
        group.count.textContent = familyTotal === 1 ? '1 máquina' : familyTotal + ' máquinas';
        if (!group.section.hidden) { group.track.scrollLeft = 0; syncControls(group); }
      });
      if (count) count.textContent = String(total);
      if (label) label.textContent = total === 1 ? 'máquina disponible' : 'máquinas disponibles';
      if (empty) empty.hidden = total !== 0;
      if (clear) clear.hidden = !query;
    };

    filters.forEach((button) => button.addEventListener('click', () => {
      activeFamily = button.dataset.scGfFilter || 'all';
      filters.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      apply();
    }));
    if (search) search.addEventListener('input', () => {
      window.cancelAnimationFrame(searchFrame);
      searchFrame = window.requestAnimationFrame(() => { query = normalize(search.value); apply(); });
    });
    if (clear && search) clear.addEventListener('click', () => {
      search.value = '';
      query = '';
      search.focus();
      apply();
    });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => controls.forEach(syncControls));
      groupsHost.querySelectorAll('[data-sc-gf-track]').forEach((track) => observer.observe(track));
    } else {
      window.addEventListener('resize', () => controls.forEach(syncControls), { passive: true });
    }
    apply();
  };

  const initializeAll = (scope) => {
    const context = scope || document;
    if (context.matches && context.matches(ROOT_SELECTOR)) initialize(context);
    context.querySelectorAll(ROOT_SELECTOR).forEach(initialize);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
